/**
 * RMFF Grants Widget TypeScript
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// Track initialization state per widget to avoid URL updates while reading from URL
var grantsInitializingMap = new WeakMap();
function initGrantsWidget() {
    var grantsWidgets = document.querySelectorAll('.rmff-grants-widget');
    grantsWidgets.forEach(function (widget) {
        initGrantsWidgetInstance(widget);
    });
}
function initGrantsWidgetInstance(widget) {
    initCustomDropdowns(widget);
    initFilterFunctionality(widget);
    initLoadMoreFunctionality(widget);
    bindHistoryEvents(widget);
    loadInitialGrants(widget);
    initActiveFiltersUI(widget);
}
function initCustomDropdowns(widget) {
    var dropdowns = widget.querySelectorAll('.rmff-custom-dropdown');
    dropdowns.forEach(function (dropdown) {
        var trigger = dropdown.querySelector('.rmff-dropdown-trigger');
        var content = dropdown.querySelector('.rmff-dropdown-content');
        if (!trigger || !content)
            return;
        trigger.addEventListener('click', function (e) {
            e.stopPropagation();
            dropdowns.forEach(function (otherDropdown) {
                if (otherDropdown !== dropdown) {
                    var otherTrigger = otherDropdown.querySelector('.rmff-dropdown-trigger');
                    var otherContent = otherDropdown.querySelector('.rmff-dropdown-content');
                    if (otherTrigger && otherContent) {
                        otherTrigger.classList.remove('active');
                        otherContent.classList.remove('active');
                    }
                }
            });
            trigger.classList.toggle('active');
            content.classList.toggle('active');
        });
        document.addEventListener('click', function () {
            trigger.classList.remove('active');
            content.classList.remove('active');
        });
        content.addEventListener('click', function (e) {
            e.stopPropagation();
        });
        initSingleSelect(dropdown);
    });
}
function initSingleSelect(dropdown) {
    var optionsContainer = dropdown.querySelector('.rmff-dropdown-options');
    if (!optionsContainer)
        return;
    optionsContainer.addEventListener('click', function (e) {
        var target = e.target;
        var option = target.closest('.rmff-dropdown-option');
        if (!option)
            return;
        // Remove selected class from all options in this dropdown
        var allOptions = optionsContainer.querySelectorAll('.rmff-dropdown-option');
        allOptions.forEach(function (opt) { return opt.classList.remove('selected'); });
        // Add selected class to clicked option
        option.classList.add('selected');
        updateDropdownLabel(dropdown);
        var widget = dropdown.closest('.rmff-grants-widget');
        if (widget) {
            updateFilters(widget);
        }
    });
}
function updateDropdownLabel(dropdown) {
    var _a;
    var trigger = dropdown.querySelector('.rmff-dropdown-trigger');
    var label = trigger === null || trigger === void 0 ? void 0 : trigger.querySelector('.rmff-dropdown-label');
    if (!trigger || !label)
        return;
    var selectedOption = dropdown.querySelector('.rmff-dropdown-option.selected');
    if (!selectedOption) {
        label.textContent = label.dataset.originalLabel || 'Select...';
    }
    else {
        var optionText = (_a = selectedOption.textContent) === null || _a === void 0 ? void 0 : _a.trim();
        label.textContent = optionText || label.dataset.originalLabel || 'Select...';
    }
}
function updateResultsCounter(widget, totalPosts) {
    var resultsCount = widget.querySelector('.rmff-results-count');
    if (resultsCount) {
        resultsCount.textContent = totalPosts.toString();
    }
}
function initFilterFunctionality(widget) {
    var keywordInput = widget.querySelector('input[data-filter="keyword"]');
    if (keywordInput) {
        var searchTimeout_1;
        keywordInput.addEventListener('input', function () {
            clearTimeout(searchTimeout_1);
            searchTimeout_1 = setTimeout(function () {
                updateFilters(widget);
            }, 1000);
        });
    }
    // remove legacy clear button hookup
    var clearAllLink = widget.querySelector('.rmff-clear-all-filters-link');
    if (clearAllLink) {
        clearAllLink.addEventListener('click', function (e) {
            e.preventDefault();
            clearAllFilters(widget);
            updateActiveFiltersUI(widget);
        });
    }
    var resetLink = widget.querySelector('.rmff-reset-link');
    if (resetLink) {
        resetLink.addEventListener('click', function (e) {
            e.preventDefault();
            clearAllFilters(widget);
            updateActiveFiltersUI(widget);
        });
    }
}
function initLoadMoreFunctionality(widget) {
    var loadMoreButton = widget.querySelector('.rmff-load-more');
    if (!loadMoreButton)
        return;
    loadMoreButton.addEventListener('click', function () {
        loadMoreGrants(widget);
    });
}
function loadInitialGrants(widget) {
    var _this = this;
    var postsPerPage = parseInt(widget.dataset.postsPerPage || '6');
    loadFilterOptions(widget).then(function () { return __awaiter(_this, void 0, void 0, function () {
        var filters;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: 
                // Initialize filters from URL after options have been populated
                return [4 /*yield*/, initializeFromURL(widget)];
                case 1:
                    // Initialize filters from URL after options have been populated
                    _a.sent();
                    filters = getCurrentFilters(widget);
                    return [4 /*yield*/, loadGrants(widget, 1, postsPerPage, filters)];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); });
}
function loadFilterOptions(widget) {
    return __awaiter(this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    return [4 /*yield*/, loadFocusAreas(widget)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, loadAmounts(widget)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, loadYears(widget)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.error('Error loading filter options:', error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function loadFocusAreas(widget) {
    return __awaiter(this, void 0, void 0, function () {
        var response, data, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch(rmff_ajax.ajax_url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                            },
                            body: new URLSearchParams({
                                action: 'get_taxonomy_terms',
                                taxonomy: 'focus-area',
                                nonce: rmff_ajax.grants_filter_nonce,
                            }),
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    if (data.success) {
                        populateDropdown(widget, 'focus_areas', data.data);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    console.error('Error loading focus areas:', error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function loadAmounts(widget) {
    return __awaiter(this, void 0, void 0, function () {
        var response, data, sortedAmounts, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch(rmff_ajax.ajax_url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                            },
                            body: new URLSearchParams({
                                action: 'get_taxonomy_terms',
                                taxonomy: 'amount',
                                nonce: rmff_ajax.grants_filter_nonce,
                            }),
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    if (data.success) {
                        sortedAmounts = data.data.sort(function (a, b) {
                            var aValue = parseFloat(a.name.replace(/[^0-9.]/g, ''));
                            var bValue = parseFloat(b.name.replace(/[^0-9.]/g, ''));
                            return aValue - bValue;
                        });
                        populateDropdown(widget, 'amounts', sortedAmounts);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _a.sent();
                    console.error('Error loading amounts:', error_3);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function loadYears(widget) {
    return __awaiter(this, void 0, void 0, function () {
        var response, data, sortedYears, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch(rmff_ajax.ajax_url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                            },
                            body: new URLSearchParams({
                                action: 'get_taxonomy_terms',
                                taxonomy: 'year-awarded',
                                nonce: rmff_ajax.grants_filter_nonce,
                            }),
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    if (data.success) {
                        sortedYears = data.data.sort(function (a, b) {
                            return parseInt(b.name) - parseInt(a.name);
                        });
                        populateDropdown(widget, 'years', sortedYears);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_4 = _a.sent();
                    console.error('Error loading years:', error_4);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function populateDropdown(widget, filterType, terms) {
    var dropdown = widget.querySelector("[data-filter=\"".concat(filterType, "\"]"));
    if (!dropdown)
        return;
    var optionsContainer = dropdown.querySelector('.rmff-dropdown-options');
    if (!optionsContainer)
        return;
    var trigger = dropdown.querySelector('.rmff-dropdown-trigger');
    var label = trigger === null || trigger === void 0 ? void 0 : trigger.querySelector('.rmff-dropdown-label');
    if (!trigger || !label)
        return;
    if (!label.dataset.originalLabel) {
        label.dataset.originalLabel = label.textContent || 'Select...';
    }
    optionsContainer.innerHTML = '';
    terms.forEach(function (term) {
        var option = document.createElement('div');
        option.className = 'rmff-dropdown-option';
        option.innerHTML = "\n            <span class=\"option-text\">".concat(term.name, "</span>\n        ");
        option.dataset.value = term.slug;
        option.dataset.name = term.name;
        optionsContainer.appendChild(option);
    });
}
function updateFilters(widget) {
    return __awaiter(this, void 0, void 0, function () {
        var filters, postsPerPage, clearButton, hasActiveFilters;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    filters = getCurrentFilters(widget);
                    if (!(filters.focus_areas.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateCategoriesDropdown(widget, filters.focus_areas)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    hideCategoriesDropdown(widget);
                    _a.label = 3;
                case 3:
                    postsPerPage = parseInt(widget.dataset.postsPerPage || '6');
                    return [4 /*yield*/, loadGrants(widget, 1, postsPerPage, filters)];
                case 4:
                    _a.sent();
                    clearButton = widget.querySelector('.rmff-clear-filters');
                    hasActiveFilters = Object.values(filters).some(function (value) {
                        return Array.isArray(value) ? value.length > 0 : value.length > 0;
                    });
                    if (clearButton) {
                        clearButton.style.display = hasActiveFilters ? 'block' : 'none';
                    }
                    // Update URL to reflect current filters unless we're initializing from URL
                    if (!getIsInitializing(widget)) {
                        updateURL(widget, filters);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function getCurrentFilters(widget) {
    var filters = {
        focus_areas: [],
        grant_categories: [],
        amounts: [],
        years: [],
        keyword: '',
    };
    var focusAreaSelected = widget.querySelector('[data-filter="focus_areas"] .rmff-dropdown-option.selected');
    if (focusAreaSelected) {
        var value = focusAreaSelected.dataset.value || '';
        filters.focus_areas.push(value);
    }
    var categorySelected = widget.querySelector('[data-filter="grant_categories"] .rmff-dropdown-option.selected');
    if (categorySelected) {
        filters.grant_categories.push(categorySelected.dataset.value || '');
    }
    var amountSelected = widget.querySelector('[data-filter="amounts"] .rmff-dropdown-option.selected');
    if (amountSelected) {
        filters.amounts.push(amountSelected.dataset.value || '');
    }
    var yearSelected = widget.querySelector('[data-filter="years"] .rmff-dropdown-option.selected');
    if (yearSelected) {
        filters.years.push(yearSelected.dataset.value || '');
    }
    var keywordInput = widget.querySelector('input[data-filter="keyword"]');
    if (keywordInput) {
        filters.keyword = keywordInput.value.trim();
    }
    return filters;
}
function updateCategoriesDropdown(widget, focusAreas) {
    return __awaiter(this, void 0, void 0, function () {
        var categoryDropdown, selectedCategoryValue, selectedOption, formData, response, data, group, optionsContainer, optionToSelect, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    categoryDropdown = widget.querySelector('[data-filter="grant_categories"]');
                    selectedCategoryValue = null;
                    if (categoryDropdown) {
                        selectedOption = categoryDropdown.querySelector('.rmff-dropdown-option.selected');
                        if (selectedOption) {
                            selectedCategoryValue = selectedOption.dataset.value || null;
                        }
                    }
                    formData = new FormData();
                    formData.append('action', 'get_grants_categories');
                    formData.append('focus_areas', JSON.stringify(focusAreas));
                    formData.append('nonce', rmff_ajax.grants_filter_nonce);
                    return [4 /*yield*/, fetch(rmff_ajax.ajax_url, {
                            method: 'POST',
                            body: formData,
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    if (data.success) {
                        if (categoryDropdown) {
                            categoryDropdown.style.display = 'block';
                            group = widget.querySelector('[data-filter-group="grant_categories_group"]');
                            if (group) {
                                group.style.display = 'block';
                            }
                            populateDropdown(widget, 'grant_categories', data.data.categories);
                            // Restore the selected category if it was previously selected
                            if (selectedCategoryValue) {
                                optionsContainer = categoryDropdown.querySelector('.rmff-dropdown-options');
                                if (optionsContainer) {
                                    optionToSelect = optionsContainer.querySelector(".rmff-dropdown-option[data-value=\"".concat(CSS.escape(selectedCategoryValue), "\"]"));
                                    if (optionToSelect) {
                                        optionToSelect.classList.add('selected');
                                        updateDropdownLabel(categoryDropdown);
                                    }
                                }
                            }
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_5 = _a.sent();
                    console.error('Error updating categories dropdown:', error_5);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function hideCategoriesDropdown(widget) {
    var categoryDropdown = widget.querySelector('[data-filter="grant_categories"]');
    if (categoryDropdown) {
        categoryDropdown.style.display = 'none';
        var group = widget.querySelector('[data-filter-group="grant_categories_group"]');
        if (group) {
            group.style.display = 'none';
        }
        var selectedOption = categoryDropdown.querySelector('.rmff-dropdown-option.selected');
        if (selectedOption) {
            selectedOption.classList.remove('selected');
        }
        updateDropdownLabel(categoryDropdown);
    }
}
function loadGrants(widget_1) {
    return __awaiter(this, arguments, void 0, function (widget, page, postsPerPage, filters) {
        var loadingElement, grantsGrid, loadMoreButton, currentFilters, formData, response, data, error_6;
        if (page === void 0) { page = 1; }
        if (postsPerPage === void 0) { postsPerPage = 6; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    loadingElement = widget.querySelector('.rmff-loading');
                    grantsGrid = widget.querySelector('.rmff-grants-grid');
                    loadMoreButton = widget.querySelector('.rmff-load-more');
                    if (!grantsGrid)
                        return [2 /*return*/];
                    if (loadingElement) {
                        loadingElement.style.display = 'block';
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    currentFilters = filters || getCurrentFilters(widget);
                    formData = new FormData();
                    formData.append('action', 'filter_grants_content');
                    formData.append('filters', JSON.stringify(currentFilters));
                    formData.append('page', page.toString());
                    formData.append('posts_per_page', postsPerPage.toString());
                    formData.append('nonce', rmff_ajax.grants_filter_nonce);
                    return [4 /*yield*/, fetch(rmff_ajax.ajax_url, {
                            method: 'POST',
                            body: formData,
                        })];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _a.sent();
                    if (data.success) {
                        if (page === 1) {
                            grantsGrid.innerHTML = '';
                        }
                        data.data.grants.forEach(function (grant) {
                            var grantElement = createGrantElement(grant);
                            grantsGrid.appendChild(grantElement);
                        });
                        if (loadMoreButton) {
                            loadMoreButton.style.display = data.data.has_more ? 'block' : 'none';
                            loadMoreButton.dataset.currentPage = page.toString();
                        }
                        // Update results counter
                        updateResultsCounter(widget, data.data.total_posts);
                        // Update active filters UI (pills and visibility)
                        updateActiveFiltersUI(widget);
                    }
                    else {
                        console.error('Error loading grants:', data.data.message);
                    }
                    return [3 /*break*/, 6];
                case 4:
                    error_6 = _a.sent();
                    console.error('Error loading grants:', error_6);
                    return [3 /*break*/, 6];
                case 5:
                    if (loadingElement) {
                        loadingElement.style.display = 'none';
                    }
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    });
}
function loadMoreGrants(widget) {
    return __awaiter(this, void 0, void 0, function () {
        var loadMoreButton, currentPage, postsPerPage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    loadMoreButton = widget.querySelector('.rmff-load-more');
                    currentPage = parseInt((loadMoreButton === null || loadMoreButton === void 0 ? void 0 : loadMoreButton.dataset.currentPage) || '1');
                    postsPerPage = parseInt(widget.dataset.postsPerPage || '6');
                    return [4 /*yield*/, loadGrants(widget, currentPage + 1, postsPerPage)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function createGrantElement(grant) {
    var element = document.createElement('div');
    element.className = 'rmff-grant-card';
    // Format amount awarded
    var amountAwarded = grant.amount_awarded
        ? "$".concat(parseInt(grant.amount_awarded).toLocaleString())
        : '';
    // Get years
    var years = grant.years.map(function (year) { return year.name; }).join(', ');
    // Get grant term
    var grantTerm = grant.grant_term
        ? "".concat(grant.grant_term, " months")
        : '';
    // Combine amount and years/term
    var amountYearsLine = [
        amountAwarded,
        years && grantTerm ? "".concat(years, " (").concat(grantTerm, ")") : years || grantTerm
    ].filter(Boolean).join(' | ');
    // Get focus areas
    var focusAreas = grant.focus_areas.map(function (area) { return area.name; }).join(', ');
    // Get grant categories
    var categories = grant.grant_categories.map(function (category) { return category.name; }).join(', ');
    // Combine focus areas and categories
    var focusCategoriesLine = [focusAreas, categories].filter(Boolean).join(' | ');
    // Get focus area icon
    var focusAreaIcon = getFocusAreaIcon(grant.focus_areas);
    // CTA button
    var ctaButton = grant.grantee_website
        ? "<a href=\"".concat(grant.grantee_website, "\" class=\"cta-button underlined\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"rmff-grant-cta\">Grantee Website &rarr;</a>")
        : '';
    element.innerHTML = "\n        ".concat(focusAreaIcon, "\n        <div class=\"rmff-grant-content\">\n            <h3 class=\"rmff-grant-title\">").concat(grant.title, "</h3>\n            ").concat(amountYearsLine ? "<div class=\"rmff-grant-amount-years\">".concat(amountYearsLine, "</div>") : '', "\n            ").concat(focusCategoriesLine ? "<div class=\"rmff-grant-focus-categories\">".concat(focusCategoriesLine, "</div>") : '', "\n            ").concat(grant.excerpt ? "<div class=\"rmff-grant-excerpt\">".concat(grant.excerpt, "</div>") : '', "\n            ").concat(ctaButton, "\n        </div>\n    ");
    return element;
}
function getFocusAreaIcon(focusAreas) {
    if (!focusAreas || focusAreas.length === 0) {
        return "<div class=\"rmff-focus-icon\">\n            <svg id=\"Other_Icon\" data-name=\"Other Icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"15\" viewBox=\"0 0 12.24 12.23\">\n                <path class=\"other-icon\" d=\"M13.62,9.47h0V1.82h0a.41.41,0,0,0-.42-.41H1.8a.41.41,0,0,0-.42.41V13.34a.28.28,0,0,0,.28.27H13.19a.41.41,0,0,0,.42-.41V9.47Zm-.87-.24a13.17,13.17,0,0,1-3.53,3.53h-3A11.88,11.88,0,0,0,11,9.17a11.44,11.44,0,0,0,1.72-2.93ZM4.9,4.91h5a8.29,8.29,0,0,1-.81,1.6H4.9ZM9.43,7.53a9.43,9.43,0,0,0,1.89-5.29h1.43a10.86,10.86,0,0,1-2.38,6.4A11.11,11.11,0,0,1,4.9,12.32v-1.5A9.55,9.55,0,0,0,9.43,7.53ZM4.05,7.37H8.47A9,9,0,0,1,6.38,9.18H4.05v3.58H2.23V2.24h8.24a9,9,0,0,1-.28,1.81H4.05Zm6.61,5.39a13.83,13.83,0,0,0,2.09-2.1v2.1Z\" transform=\"translate(-1.38 -1.39)\"></path>\n            </svg>\n        </div>";
    }
    var primaryFocusArea = focusAreas[0].slug;
    if (primaryFocusArea === 'health') {
        return "<div class=\"rmff-focus-icon rmff-focus-health\">\n            <svg id=\"Heart_Icon\" data-name=\"Heart Icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"15\" viewBox=\"0 0 14.73 13\">\n                <path class=\"heart-icon\" d=\"M13.7,2.16a4,4,0,0,0-5.63,0l-.56.58-.58-.58A4,4,0,0,0,1.3,7.79L7.51,14l6.2-6.21A4,4,0,0,0,13.7,2.16ZM10.41,7.63a.16.16,0,0,1-.16.16H8.12V9.92a.16.16,0,0,1-.16.16H7a.16.16,0,0,1-.16-.16V7.79H4.75a.16.16,0,0,1-.16-.16V6.72a.16.16,0,0,1,.16-.16H6.88V4.43A.17.17,0,0,1,7,4.26H8a.17.17,0,0,1,.16.17V6.56h2.13a.16.16,0,0,1,.16.16Z\" transform=\"translate(-0.14 -1)\"></path>\n            </svg>\n        </div>";
    }
    else if (primaryFocusArea === 'education') {
        return "<div class=\"rmff-focus-icon rmff-focus-education\">\n            <svg id=\"Education_Icon\" data-name=\"Education Icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"15\" viewBox=\"0 0 19.55 12.47\">\n                <g>\n                    <path class=\"education-1\" d=\"M15.79,8.15,10,10.65a.13.13,0,0,1-.12,0L3.67,8a.17.17,0,0,0-.23.17l-.1,3.12a.17.17,0,0,0,.05.14A9,9,0,0,0,10,13.73c4.12-.07,6-1.92,6.28-2.27a.17.17,0,0,0,0-.14l-.25-3A.19.19,0,0,0,15.79,8.15Z\" transform=\"translate(-0.23 -1.26)\"></path>\n                    <path class=\"education-1\" d=\"M.31,5.18,9.88,1.27a.14.14,0,0,1,.09,0L19.69,5.1a.14.14,0,0,1,0,.25L10.05,9.42H10l-9.65-4A.14.14,0,0,1,.31,5.18Z\" transform=\"translate(-0.23 -1.26)\"></path>\n                    <line class=\"education-2\" x1=\"1.46\" y1=\"4.3\" x2=\"1.46\" y2=\"8.01\"></line>\n                </g>\n            </svg>\n        </div>";
    }
    else if (primaryFocusArea === 'vitality-of-indianapolis') {
        return "<div class=\"rmff-focus-icon rmff-focus-vitality\">\n            <svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 131.48 131.48\">\n                <defs>\n                    <style>\n                    .cls-1 {\n                        fill: #bad739;\n                    }\n                    </style>\n                </defs>\n                <path class=\"cls-1\" d=\"M126.57,40.78c-6.67-16.22-19.63-29.2-35.86-35.86-7.7-3.17-16.12-4.92-24.97-4.92s-17.27,1.75-24.97,4.91C24.55,11.57,11.57,24.55,4.92,40.78,1.75,48.48,0,56.91,0,65.75s1.75,17.27,4.92,24.97c6.65,16.22,19.63,29.2,35.86,35.86,7.7,3.16,16.12,4.91,24.97,4.91s17.27-1.75,24.97-4.91c16.22-6.67,29.2-19.64,35.86-35.86,3.16-7.7,4.91-16.12,4.91-24.97s-1.75-17.27-4.91-24.97ZM93.68,104.92l-26.85-19.51-26.87,19.51,10.27-31.57-26.87-19.52h33.2l10.27-31.57,10.25,31.57h33.2l-26.87,19.52,10.27,31.57Z\"/>\n            </svg>\n        </div>";
    }
    else {
        return "<div class=\"rmff-focus-icon rmff-focus-other\">\n            <svg id=\"Other_Icon\" data-name=\"Other Icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"15\" viewBox=\"0 0 12.24 12.23\">\n                <path class=\"other-icon\" d=\"M13.62,9.47h0V1.82h0a.41.41,0,0,0-.42-.41H1.8a.41.41,0,0,0-.42.41V13.34a.28.28,0,0,0,.28.27H13.19a.41.41,0,0,0,.42-.41V9.47Zm-.87-.24a13.17,13.17,0,0,1-3.53,3.53h-3A11.88,11.88,0,0,0,11,9.17a11.44,11.44,0,0,0,1.72-2.93ZM4.9,4.91h5a8.29,8.29,0,0,1-.81,1.6H4.9ZM9.43,7.53a9.43,9.43,0,0,0,1.89-5.29h1.43a10.86,10.86,0,0,1-2.38,6.4A11.11,11.11,0,0,1,4.9,12.32v-1.5A9.55,9.55,0,0,0,9.43,7.53ZM4.05,7.37H8.47A9,9,0,0,1,6.38,9.18H4.05v3.58H2.23V2.24h8.24a9,9,0,0,1-.28,1.81H4.05Zm6.61,5.39a13.83,13.83,0,0,0,2.09-2.1v2.1Z\" transform=\"translate(-1.38 -1.39)\"></path>\n            </svg>\n        </div>";
    }
}
function clearAllFilters(widget) {
    var selectedOptions = widget.querySelectorAll('.rmff-dropdown-option.selected');
    selectedOptions.forEach(function (option) {
        option.classList.remove('selected');
    });
    var keywordInput = widget.querySelector('input[data-filter="keyword"]');
    if (keywordInput) {
        keywordInput.value = '';
    }
    var dropdowns = widget.querySelectorAll('.rmff-custom-dropdown');
    dropdowns.forEach(function (dropdown) {
        updateDropdownLabel(dropdown);
    });
    hideCategoriesDropdown(widget);
    var clearButton = widget.querySelector('.rmff-clear-filters');
    if (clearButton) {
        clearButton.style.display = 'none';
    }
    var postsPerPage = parseInt(widget.dataset.postsPerPage || '6');
    loadGrants(widget, 1, postsPerPage);
    // Clear URL parameters
    if (!getIsInitializing(widget)) {
        updateURL(widget, getCurrentFilters(widget));
    }
}
export { initGrantsWidget };
// -----------------------------
// URL Sync Helpers (mirrors reports behavior)
// -----------------------------
function setIsInitializing(widget, value) {
    grantsInitializingMap.set(widget, value);
}
function getIsInitializing(widget) {
    return grantsInitializingMap.get(widget) === true;
}
function getURLParameters() {
    var urlParams = new URLSearchParams(window.location.search);
    return {
        focus_areas: urlParams.get('focus_areas') || undefined,
        grant_categories: urlParams.get('grant_categories') || undefined,
        amounts: urlParams.get('amounts') || undefined,
        years: urlParams.get('years') || undefined,
        keywords: urlParams.get('keywords') || undefined
    };
}
function initializeFromURL(widget) {
    return __awaiter(this, void 0, void 0, function () {
        var params, selectOption, focusAreaFromURL, areas, cats, catVal, categoryDropdown, amts, yrs, keywordInput, filters, clearButton, hasActiveFilters;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = getURLParameters();
                    setIsInitializing(widget, true);
                    selectOption = function (dropdownAttr, value) {
                        var dropdown = widget.querySelector("[data-filter=\"".concat(dropdownAttr, "\"]"));
                        if (!dropdown)
                            return;
                        var optionsContainer = dropdown.querySelector('.rmff-dropdown-options');
                        if (!optionsContainer)
                            return;
                        // Clear previous selection
                        optionsContainer.querySelectorAll('.rmff-dropdown-option.selected').forEach(function (opt) { return opt.classList.remove('selected'); });
                        // Select matching
                        var option = optionsContainer.querySelector(".rmff-dropdown-option[data-value=\"".concat(CSS.escape(value), "\"]"));
                        if (option) {
                            option.classList.add('selected');
                            updateDropdownLabel(dropdown);
                        }
                    };
                    focusAreaFromURL = null;
                    if (!params.focus_areas) return [3 /*break*/, 2];
                    areas = params.focus_areas.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
                    if (!(areas.length > 0)) return [3 /*break*/, 2];
                    focusAreaFromURL = areas[0];
                    selectOption('focus_areas', focusAreaFromURL);
                    // Update categories based on selected focus area before selecting category
                    return [4 /*yield*/, updateCategoriesDropdown(widget, [focusAreaFromURL])];
                case 1:
                    // Update categories based on selected focus area before selecting category
                    _a.sent();
                    _a.label = 2;
                case 2:
                    // Category (depends on focus area, single select currently)
                    if (params.grant_categories) {
                        cats = params.grant_categories.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
                        if (cats.length > 0) {
                            catVal = cats[0];
                            categoryDropdown = widget.querySelector('[data-filter="grant_categories"]');
                            if (categoryDropdown) {
                                categoryDropdown.style.display = 'block';
                            }
                            selectOption('grant_categories', catVal);
                        }
                    }
                    // Amount (single select currently)
                    if (params.amounts) {
                        amts = params.amounts.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
                        if (amts.length > 0) {
                            selectOption('amounts', amts[0]);
                        }
                    }
                    // Year (single select currently)
                    if (params.years) {
                        yrs = params.years.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
                        if (yrs.length > 0) {
                            selectOption('years', yrs[0]);
                        }
                    }
                    // Keyword
                    if (params.keywords) {
                        keywordInput = widget.querySelector('input[data-filter="keyword"]');
                        if (keywordInput) {
                            keywordInput.value = params.keywords;
                        }
                    }
                    // Ensure categories dropdown visibility reflects current focus area selection
                    if (!focusAreaFromURL) {
                        hideCategoriesDropdown(widget);
                    }
                    filters = getCurrentFilters(widget);
                    clearButton = widget.querySelector('.rmff-clear-filters');
                    hasActiveFilters = Object.values(filters).some(function (value) {
                        return Array.isArray(value) ? value.length > 0 : value.length > 0;
                    });
                    if (clearButton) {
                        clearButton.style.display = hasActiveFilters ? 'block' : 'none';
                    }
                    setIsInitializing(widget, false);
                    return [2 /*return*/];
            }
        });
    });
}
function updateURL(widget, filters) {
    var url = new URL(window.location.href);
    // Focus areas
    if (filters.focus_areas && filters.focus_areas.length > 0) {
        url.searchParams.set('focus_areas', filters.focus_areas.join(','));
    }
    else {
        url.searchParams.delete('focus_areas');
    }
    // Grant categories
    if (filters.grant_categories && filters.grant_categories.length > 0) {
        url.searchParams.set('grant_categories', filters.grant_categories.join(','));
    }
    else {
        url.searchParams.delete('grant_categories');
    }
    // Amounts
    if (filters.amounts && filters.amounts.length > 0) {
        url.searchParams.set('amounts', filters.amounts.join(','));
    }
    else {
        url.searchParams.delete('amounts');
    }
    // Years
    if (filters.years && filters.years.length > 0) {
        url.searchParams.set('years', filters.years.join(','));
    }
    else {
        url.searchParams.delete('years');
    }
    // Keywords (note reports uses 'keywords')
    if (filters.keyword && filters.keyword.length > 0) {
        url.searchParams.set('keywords', filters.keyword);
    }
    else {
        url.searchParams.delete('keywords');
    }
    window.history.pushState({}, '', url.toString());
}
function bindHistoryEvents(widget) {
    var _this = this;
    var reapplyFromURL = function () {
        initializeFromURL(widget).then(function () { return __awaiter(_this, void 0, void 0, function () {
            var postsPerPage, filters;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        postsPerPage = parseInt(widget.dataset.postsPerPage || '6');
                        filters = getCurrentFilters(widget);
                        return [4 /*yield*/, loadGrants(widget, 1, postsPerPage, filters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    window.addEventListener('popstate', reapplyFromURL);
    window.addEventListener('pageshow', function (event) {
        var e = event;
        if (!e || e.persisted === true || e.persisted === false) {
            reapplyFromURL();
        }
    });
}
// -----------------------------
// Active Filters UI (pills + visibility)
// -----------------------------
function initActiveFiltersUI(widget) {
    // Clicking a pill removes that filter
    var pillsContainer = widget.querySelector('.rmff-filter-pills');
    if (!pillsContainer)
        return;
    pillsContainer.addEventListener('click', function (e) {
        var target = e.target;
        var pill = target.closest('.rmff-filter-pill');
        if (!pill)
            return;
        var type = pill.getAttribute('data-type');
        var value = pill.getAttribute('data-value') || '';
        if (!type)
            return;
        if (type === 'keyword') {
            var keywordInput = widget.querySelector('input[data-filter="keyword"]');
            if (keywordInput)
                keywordInput.value = '';
        }
        else if (type === 'focus_areas' || type === 'grant_categories' || type === 'amounts' || type === 'years') {
            var dropdown = widget.querySelector("[data-filter=\"".concat(type, "\"]"));
            if (dropdown) {
                var selected = dropdown.querySelector(".rmff-dropdown-option.selected[data-value=\"".concat(CSS.escape(value), "\"]"));
                if (selected) {
                    selected.classList.remove('selected');
                    updateDropdownLabel(dropdown);
                }
                // Special: If focus area cleared, hide categories
                if (type === 'focus_areas') {
                    hideCategoriesDropdown(widget);
                }
            }
        }
        updateFilters(widget);
    });
}
function updateActiveFiltersUI(widget) {
    var pillsContainer = widget.querySelector('.rmff-filter-pills');
    var activeFiltersRow = widget.querySelector('.rmff-active-filters');
    var resetLink = widget.querySelector('.rmff-reset-link');
    if (!pillsContainer || !activeFiltersRow)
        return;
    var filters = getCurrentFilters(widget);
    var hasActive = (filters.keyword && filters.keyword.length > 0) ||
        filters.focus_areas.length > 0 ||
        filters.grant_categories.length > 0 ||
        filters.amounts.length > 0 ||
        filters.years.length > 0;
    // Show/hide active filters row and reset link
    activeFiltersRow.style.display = hasActive ? 'flex' : 'none';
    if (resetLink)
        resetLink.style.display = hasActive ? 'block' : 'none';
    // Update pills
    pillsContainer.innerHTML = '';
    if (filters.keyword) {
        pillsContainer.appendChild(createPill('keyword', filters.keyword));
    }
    addDropdownPill(widget, 'focus_areas', 'Focus Area');
    addDropdownPill(widget, 'grant_categories', 'Category');
    addDropdownPill(widget, 'amounts', 'Amount');
    addDropdownPill(widget, 'years', 'Year');
}
function addDropdownPill(widget, filterKey, _label) {
    var pillsContainer = widget.querySelector('.rmff-filter-pills');
    if (!pillsContainer)
        return;
    var dropdown = widget.querySelector("[data-filter=\"".concat(filterKey, "\"]"));
    if (!dropdown)
        return;
    // Try to find selected option - check both .selected class and also check by value from filters
    var selected = dropdown.querySelector('.rmff-dropdown-option.selected');
    // If no selected option found by class, try to find it by value from getCurrentFilters
    if (!selected) {
        var filters = getCurrentFilters(widget);
        var filterValue = filters[filterKey] && filters[filterKey].length > 0 ? filters[filterKey][0] : null;
        if (filterValue) {
            selected = dropdown.querySelector(".rmff-dropdown-option[data-value=\"".concat(CSS.escape(filterValue), "\"]"));
        }
    }
    if (!selected)
        return;
    var name = (selected.dataset.name || selected.textContent || '').trim();
    var value = selected.dataset.value || '';
    if (!name)
        return;
    var pill = document.createElement('div');
    pill.className = 'rmff-filter-pill';
    pill.setAttribute('data-type', filterKey);
    pill.setAttribute('data-value', value);
    pill.innerHTML = "<span>".concat(name, "</span><button type=\"button\" class=\"rmff-pill-remove\" aria-label=\"Remove ").concat(_label, " filter\">\u00D7</button>");
    pillsContainer.appendChild(pill);
}
function createPill(type, value) {
    var pill = document.createElement('div');
    pill.className = 'rmff-filter-pill';
    pill.setAttribute('data-type', type);
    pill.setAttribute('data-value', value);
    pill.innerHTML = "<span>".concat(value, "</span><button type=\"button\" class=\"rmff-pill-remove\" aria-label=\"Remove ").concat(type, " filter\">\u00D7</button>");
    return pill;
}
